import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Star, Users, Database, Smartphone } from 'lucide-react';
import BottomNav from '../components/BottomNav';

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B0B0C] text-white pb-24">
      {/* Header */}
      <div className="sticky top-0 bg-[#0B0B0C]/95 backdrop-blur-sm z-10 px-4 py-4 border-b border-white/10">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="text-white/70 hover:text-white"
          >
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-bold">About Cigar Ranker</h1>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 py-6 max-w-3xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-8">
          <h2 className="playfair text-3xl text-amber-500 font-bold mb-3">Cigar Ranker</h2>
          <p className="text-white/70">
            Your personal cigar companion for discovering, rating, and tracking the world's finest cigars.
          </p>
        </div>

        {/* Features */}
        <div className="space-y-6 mb-8">
          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Star className="text-amber-500" size={20} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Rate & Review</h3>
                <p className="text-white/60 text-sm">
                  Rate cigars on a precise 0-10 scale and share your tasting notes with the community.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Database className="text-amber-500" size={20} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Extensive Database</h3>
                <p className="text-white/60 text-sm">
                  Browse over 1,000 cigars from top brands worldwide, with detailed information on strength, origin, wrapper, and flavor profiles.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Smartphone className="text-amber-500" size={20} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">AI-Powered Scanner</h3>
                <p className="text-white/60 text-sm">
                  Use your camera to instantly identify cigars. Our AI reads cigar bands and matches them to our database.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Users className="text-amber-500" size={20} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Community Driven</h3>
                <p className="text-white/60 text-sm">
                  Join fellow aficionados in discussions, see what's trending on the leaderboards, and discover new favorites.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Version Info */}
        <div className="text-center border-t border-white/10 pt-6">
          <p className="text-white/40 text-sm mb-2">Version 1.0</p>
          <p className="text-white/40 text-sm">
            Made with passion for cigar enthusiasts everywhere.
          </p>
        </div>

        {/* Links */}
        <div className="mt-6 flex flex-col gap-3">
          <button
            onClick={() => navigate('/privacy-policy')}
            className="text-amber-500 hover:text-amber-400 text-sm"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => navigate('/terms-of-service')}
            className="text-amber-500 hover:text-amber-400 text-sm"
          >
            Terms of Service
          </button>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default AboutPage;
